import { lazy, Suspense } from 'react';

import Guest from 'src/components/Guest';
import SuspenseLoader from 'src/components/SuspenseLoader';

const Loader = (Component) => (props) =>
  (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  );

// Account Routes
const LoginCover = Loader(
  lazy(() => import('src/content/commons/Auth/Login/Cover'))
);
const VendorLoginCover = Loader(
  lazy(() => import('src/content/commons/Auth/vendor-login/Cover'))
);
const VendorRegisterCover = Loader(
  lazy(() => import('src/content/commons/Auth/vendor-register/Cover'))
);
const RegisterCover = Loader(
  lazy(() => import('src/content/commons/Auth/Register/Cover'))
);
const RegisterWizard = Loader(
  lazy(() => import('src/content/commons/Auth/Register/Wizard'))
);
const RecoverPassword = Loader(
  lazy(() => import('src/content/commons/Auth/RecoverPassword'))
);

const RecoverVendorPassword = Loader(
  lazy(
    () => import('src/content/commons/Auth/vendor-login/RecoverPasswordVendor')
  )
);

const accountRoutes = [
  {
    path: 'login',
    element: (
      <Guest>
        <LoginCover />
      </Guest>
    )
  },
  {
    path: 'vendor/login',
    element: (
      <Guest>
        <VendorLoginCover />
      </Guest>
    )
  },
  {
    path: 'vendor/register/:value',
    element: (
      <Guest>
        <VendorRegisterCover />
      </Guest>
    )
  },
  {
    path: 'vendor/forget-password',
    element: <RecoverVendorPassword />
  },

  {
    path: 'register',
    element: (
      <Guest>
        <RegisterCover />
      </Guest>
    )
  },
  {
    path: 'login-cover',
    element: <LoginCover />
  },
  {
    path: 'forget-password',
    element: <RecoverPassword />
  },
  {
    path: 'register',
    element: (
      <Guest>
        <RegisterCover />
      </Guest>
    )
  },
  {
    path: 'register-cover',
    element: <RegisterCover />
  },
  {
    path: 'register-wizard',
    element: <RegisterWizard />
  }
];

export default accountRoutes;
